/**!
 * Created by Leonardo Cheslacki on 21/08/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import SupportController from './SupportController';

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class SupportMask extends SupportController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {};

        _this = this;
    };

    /**
     *
     * @type {{onMouse: function(*): void}}
     */
    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    /**
     *
     * @param string
     * @returns {boolean}
     */
    getMask = (string) => {
        const {regex} = this.props;

        let isRegex = `/${regex}/g`, search = `/^${regex}$/g`;

        return (!this.isEmpty(string) && (new RegExp(isRegex)).test(string)) ? this.firstArray(string.toString().match(new RegExp(search))) : false;
    };

    /**
     *
     * @param string
     * @returns {*}
     */
    number = (string) => {
        return string.replace(/\D/g, '');
    };

    /**
     *
     * @param string
     * @returns {*}
     */
    zero = (string) => {
        return string.replace(/^0+/g, '');
    };

    phone = (string) => {
        return this.zero(this.number(string))
            .substring(0, 10)
            .replace(/(\d{0})(\d)/, '$1($2')
            .replace(/(\d{2})(\d)/, '$1)$2')
            .replace(/(\d{4})(\d)/, '$1-$2');
    };

    /**
     *
     * @param string
     * @returns {string}
     */
    cell = (string) => {
        return this.zero(this.number(string))
            .substring(0, 11)
            .replace(/(\d{0})(\d)/, '$1($2')
            .replace(/(\d{2})(\d)/, '$1)$2')
            .replace(/(\d{5})(\d)/, '$1-$2');
    };

    /**
     *
     * @param string
     * @returns {*|string}
     */
    phoneAndCell = (string) => {
        if (this.zero(this.number(string)).length < 11) {
            return this.phone(string);
        } else {
            return this.cell(string);
        }
    };
}

/**
 *
 * @type {{}}
 */
SupportMask.propTypes = {
    regex: PropTypes.string
};

/**
 *
 * @type {{}}
 */
SupportMask.defaultProps = {
    regex: 'password|email|number|string|phone|cell|phoneAndCell|cpf|cnpj|cpfAndcnpj|zip|money|fractionMedium|fractionFull|complement|code'
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(SupportMask, {className: 'SupportMask'});
